/** URL builders for the supply-chain monitoring area, all scoped to a client. */
export const monitoringPaths = {
  base: '/supplychain/monitoring',

  overview: (clientId: number | string) => `/supplychain/monitoring/${clientId}`,

  supplier: (clientId: number | string, supplierId: number | string) =>
    `/supplychain/monitoring/${clientId}/supplier/${supplierId}`,

  incident: (clientId: number | string, supplierId: number | string, incidentId: number | string) =>
    `/supplychain/monitoring/${clientId}/supplier/${supplierId}/incident/${incidentId}`,

  riskAssessment: (
    clientId: number | string,
    supplierId: number | string,
    assessmentId: number | string
  ) => `/supplychain/monitoring/${clientId}/supplier/${supplierId}/risk-assessment/${assessmentId}`,
};
